import ApiActions from "api_actions";
import isCarProperty from "utils/is_car_property";

export const SET_SUBMITTED_VALUE = "SET_SUBMITTED_VALUE";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FORM_SUBMITTING = "SET_FORM_SUBMITTING";
export const SET_FORM_SUBMIT_COMPLETE = "SET_FORM_SUBMIT_COMPLETE";
export const SET_FORM_SUBMIT_ERROR = "SET_FORM_SUBMIT_ERROR";
export const SET_SUBMIT_HANDLER = "SET_SUBMIT_HANDLER";

const setSubmittedValue = (dispatch, payload) => {
  return dispatch({ type: SET_SUBMITTED_VALUE, payload });
};

const setErrors = (dispatch, payload) => {
  return dispatch({ type: SET_ERRORS, payload });
};

const setFormSubmitting = (dispatch) => {
  return dispatch({ type: SET_FORM_SUBMITTING });
};

const setFormSubmitComplete = (dispatch) => {
  return dispatch({ type: SET_FORM_SUBMIT_COMPLETE });
};

const setSubmitHandler = (dispatch, payload) => {
  return dispatch({ type: SET_SUBMIT_HANDLER, payload });
};

const setFormSubmitError = (dispatch, payload) => {
  return dispatch({ dispatch, payload });
};

const createBooking = async (dispatch, channelId, type, formParams, bookingParams) => {
  setFormSubmitting(dispatch);
  setSubmittedValue(dispatch, formParams);

  try {
    let newBookingInfo;
    if (isCarProperty(type)) {
      newBookingInfo = await ApiActions.createVehicleBooking(channelId, type, formParams, bookingParams);
    } else {
      newBookingInfo = await ApiActions.createAccommodationBooking(channelId, type, formParams, bookingParams);
    }

    setFormSubmitComplete(dispatch);

    return newBookingInfo;
  } catch (error) {
    setFormSubmitError(dispatch, error);

    throw error;
  }
};

export const actions = {
  setErrors,
  setFormSubmitting,
  setFormSubmitComplete,
  setSubmitHandler,
  createBooking,
};
